import React, { useMemo } from 'react';
import { shallowEqual, useSelector } from 'umi';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
import moment from 'moment';
import { PERIODTIMEOBJ } from '@/pages/dashboard/_config/constant';

export default function IngamePayerOrArpuService(props: any) {
  const { style, className, config, children, ...resetProps } = props || {};
  const { api, dataKey, metrics, payerResKey, arpuResKey, serviceParams: restApiConfig } = config || {};
  const { gameCode } = useSelector((state: any) => ({
    gameCode: state?.dashboard?.currentGame?.game_code
  }), shallowEqual);

  const data = useMemo(() => ({
    gameCode,
  }), [gameCode]);

  // 格式化接口数据为组件需要的数据格式
  const transformNewDataToOldFormat = (data: any[]) => {
    const transformedData = {
      "mtx_payer_and_rate": [],
      "mtx_arpu_and_arppu": []
    };
  
    // 无数据时，后端返回的是null，则不对数据做后续转换
    if(!data) {
      return transformedData;
    }
    data.forEach((item: { date: any; metrics: { [x: string]: { value: any; }; }; }) => {
      const mtxEntry = {
        date: item.date,
        system: "",
        metrics: {
          [payerResKey?.[0]]: {
            value: item?.metrics?.[payerResKey?.[0]]?.value,
            dod: "",
            sdlw: "",
            change: ""
          },
          [payerResKey?.[1]]: {
            value: item?.metrics?.[payerResKey?.[1]]?.value,
            dod: "",
            sdlw: "",
            change: ""
          }
        }
      };
  
      const platformEntry = {
        date: item.date,
        system: "",
        metrics: {
          [arpuResKey?.[0]]: {
            value: item?.metrics?.[arpuResKey?.[0]]?.value,
            dod: "",
            sdlw: "",
            change: ""
          },
          [arpuResKey?.[1]]: {
            value: item?.metrics?.[arpuResKey?.[1]]?.value,
            dod: "",
            sdlw: "",
            change: ""
          }
        }
      };
  
      transformedData.mtx_payer_and_rate.push(mtxEntry);
      transformedData.mtx_arpu_and_arppu.push(platformEntry);
    });
  
    return transformedData;
  };

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={data}
        dataKey={dataKey}
        formatData={transformNewDataToOldFormat}
        beforeRequest={data => {
          const { filterVal } = data;
          const { timeType, rangeTime, ...filters } = filterVal;
          const params: { [key in string]: unknown } = {
            game_code: gameCode,
            start_time: moment(rangeTime?.[0]).format('YYYY-MM-DD'),
            end_time: moment(rangeTime?.[1]).format('YYYY-MM-DD'),
            period: PERIODTIMEOBJ[timeType],
            filters: formatFilterValues(filters),
            metrics,
            ...restApiConfig
          };

          return params;
        }}
        trackData={['gameCode']}
      >
        {React.Children.map(children, (child: any) => React.cloneElement(child, {
          ...resetProps
        }))}
      </Service>
    </div>
  );
}
